import React, {useEffect, useRef, useState} from 'react';
import {Box, Typography} from '@mui/material';
import carImage from '../../../public/automotive_image/car.png';
import adasImage from '../../../public/automotive_image/adas.png';
import powerTrainImage from '../../../public/automotive_image/powertrain.png';
import vehicleElectrificationImage from '../../../public/automotive_image/vehicleElectrification.png';
import infotainmentImage from '../../../public/automotive_image/infotainment.png';
import bodyElectronicsImage from '../../../public/automotive_image/bodyElectronics.png';

import circleIcon1 from '../../../public/automotive_image/circle_Animation/circle_1.png';
import circleIcon2 from '../../../public/automotive_image/circle_Animation/circle_2.png';
import circleIcon3 from '../../../public/automotive_image/circle_Animation/circle_3.png';
import circleIcon4 from '../../../public/automotive_image/circle_Animation/circle_4.png';
import {GetResponsiveWidth} from '../common/TabsComponent';
import {useResponsive} from '../../contexts/ResponsiveContext';
import {useNavigate} from 'react-router-dom';
import {ApplicationsContent} from '../../graphql/pimcore/modules/siteContent/types/ApplicationsContent';
import type {StaticImageData} from 'next/image';
import Image from 'next/image';

export type ComponentType =
    | 'powertrain'
    | 'adas'
    | 'vehicleElectrification'
    | 'bodyElectronics'
    | 'industrial'
    | 'homeConsumer'
    | 'default';

export const useResponsiveMargins = (type: ComponentType) => {
    const { isScreenXl, isScreenLg, isScreenMd, isScreenSm, isScreenXs } = useResponsive();

    switch (type) {
        case 'powertrain':
            if (isScreenXl) return { marginTop: '1rem', marginBottom: '1rem', marginLeft: '5rem' };
            else if (isScreenLg)
                return { marginTop: '0.9rem', marginBottom: '0.9rem', marginLeft: '4rem' };
            else if (isScreenMd)
                return { marginTop: '0.8rem', marginBottom: '0.8rem', marginLeft: '3rem' };
            else if (isScreenSm)
                return { marginTop: '0.7rem', marginBottom: '0.7rem', marginLeft: '2rem' };
            else if (isScreenXs)
                return { marginTop: '0.6rem', marginBottom: '0.6rem', marginLeft: '1rem' };
            return { marginTop: '1rem', marginBottom: '1rem', marginLeft: '5rem' };

        case 'adas':
            if (isScreenXl) return { marginTop: '2rem', marginLeft: '1rem' };
            else if (isScreenLg) return { marginTop: '1.8rem', marginLeft: '0.9rem' };
            else if (isScreenMd) return { marginTop: '1.5rem', marginLeft: '0.8rem' };
            else if (isScreenSm) return { marginTop: '1.2rem', marginLeft: '0.7rem' };
            else if (isScreenXs) return { marginTop: '1rem', marginLeft: '0.5rem' };
            return { marginTop: '2rem', marginLeft: '1rem' };

        case 'vehicleElectrification':
            if (isScreenXl) return { marginTop: '1rem', marginBottom: '1rem', marginLeft: '5rem' };
            else if (isScreenLg)
                return { marginTop: '0.9rem', marginBottom: '0.9rem', marginLeft: '4rem' };
            else if (isScreenMd)
                return { marginTop: '0.8rem', marginBottom: '0.8rem', marginLeft: '3rem' };
            else if (isScreenSm)
                return { marginTop: '0.7rem', marginBottom: '0.7rem', marginLeft: '2rem' };
            else if (isScreenXs)
                return { marginTop: '0.6rem', marginBottom: '0.6rem', marginLeft: '1rem' };
            return { marginTop: '1rem', marginBottom: '1rem', marginLeft: '5rem' };

        case 'bodyElectronics':
            if (isScreenXl) return { marginTop: '3rem', marginBottom: '1rem', marginLeft: '6rem' };
            else if (isScreenLg)
                return { marginTop: '2.5rem', marginBottom: '0.8rem', marginLeft: '5rem' };
            else if (isScreenMd)
                return { marginTop: '2rem', marginBottom: '0.7rem', marginLeft: '4rem' };
            else if (isScreenSm)
                return { marginTop: '1.5rem', marginBottom: '0.5rem', marginLeft: '2rem' };
            else if (isScreenXs)
                return { marginTop: '1rem', marginBottom: '0.3rem', marginLeft: '1rem' };
            return { marginTop: '3rem', marginBottom: '1rem', marginLeft: '6rem' };

        case 'industrial':
            if (isScreenXl) return { paddingTop: '10rem', marginTop: '3rem', marginLeft: '1rem' };
            else if (isScreenLg)
                return { paddingTop: '8rem', marginTop: '2.5rem', marginLeft: '1rem' };
            else if (isScreenMd)
                return { paddingTop: '5.5rem', marginTop: '2rem', marginLeft: '0.8rem' };
            else if (isScreenSm)
                return { paddingTop: '3.5rem', marginTop: '1.5rem', marginLeft: '0.7rem' };
            else if (isScreenXs)
                return { paddingTop: '2rem', marginTop: '1rem', marginLeft: '0.3rem' };
            return { paddingTop: '10rem', marginTop: '3rem', marginLeft: '1rem' };

        case 'homeConsumer':
            if (isScreenXl)
                return { marginBottom: '2rem', marginTop: '3.5rem', marginLeft: '8rem' };
            else if (isScreenLg)
                return { marginBottom: '1.5rem', marginTop: '3rem', marginLeft: '6rem' };
            else if (isScreenMd)
                return { marginBottom: '1rem', marginTop: '2.5rem', marginLeft: '5rem' };
            else if (isScreenSm)
                return { marginBottom: '0.7rem', marginTop: '2rem', marginLeft: '3rem' };
            else if (isScreenXs)
                return { marginBottom: '0.4rem', marginTop: '1rem', marginLeft: '2rem' };
            return { marginBottom: '2rem', marginTop: '3.5rem', marginLeft: '8rem' };
        case 'default':
        default:
            return {};
    }
};

interface AnnotationProps {
    label: string | string[];
    pointX: number;
    pointY: number;
    labelX: number;
    labelY: number;
    gap?: number;
    labelGap?: number;
    onClick?: () => void;
    offsetGap?: number;
    isInfotainment?: boolean;
    lineStartAdjust?: number;
    lineEndAdjust?: number;
    lineLengthAdjust?: number;
    lineToLabelGap?: number;
    lineToPointGap?: number;
}

const circleIcons: (string | StaticImageData)[] = [
    circleIcon1,
    circleIcon2,
    circleIcon3,
    circleIcon4,
];
const wrapText = (text: string, maxChars = 24): string[] => {
    const words = text.split(' ');
    const lines: string[] = [];
    let currentLine = '';

    for (let word of words) {
        if ((currentLine + word).length > maxChars) {
            lines.push(currentLine.trim());
            currentLine = word + ' ';
        } else {
            currentLine += word + ' ';
        }
    }

    if (currentLine.trim()) {
        lines.push(currentLine.trim());
    }

    return lines;
};

const VIEWBOX_HEIGHT = 543; // 與 AnnotatedImage 的 viewBox 高度一致
const CLAMP_PADDING = 4; // 與底邊留白

export const Annotation: React.FC<AnnotationProps> = ({
    label,
    pointX,
    pointY,
    labelX,
    labelY,
    gap,
    labelGap,
    onClick,
    offsetGap,
    isInfotainment,
    lineStartAdjust,
    lineEndAdjust,
    lineLengthAdjust,
    lineToLabelGap,
    lineToPointGap,
}) => {
    const [currentIcon, setCurrentIcon] = useState(0);
    const [isHovered, setIsHovered] = useState(false);
    const [isLabelHovered, setIsLabelHovered] = useState(false);
    const { isScreenMd, isScreenSm, isScreenXs } = useResponsive();
    const [textWidth, setTextWidth] = useState(0);
    const textRef = useRef<SVGTextElement>(null);

    const fontSize = isScreenMd ? 27 : isScreenSm ? 32 : isScreenXs ? 34 : 24;

    const wrappedLines = typeof label === 'string' ? wrapText(label, 24) : [];

    useEffect(() => {
        let interval: NodeJS.Timeout;

        if (isHovered || isLabelHovered) {
            interval = setInterval(() => {
                setCurrentIcon((prevIcon) => (prevIcon + 1) % circleIcons.length);
            }, 110);
        } else {
            setCurrentIcon(0);
        }

        return () => clearInterval(interval);
    }, [isHovered, isLabelHovered]);

    useEffect(() => {
        if (textRef.current) {
            const bbox = textRef.current.getBBox();
            setTextWidth(bbox.width);
        }
    }, [label]);

    const deltaX = labelX - pointX;
    const deltaY = labelY - pointY;
    const distance = Math.sqrt(deltaX * deltaX + deltaY * deltaY) + (lineLengthAdjust ?? 0);
    const unitX = deltaX / distance;
    const unitY = deltaY / distance;

    const modifiedLabelY =
        isScreenMd || isScreenSm || isScreenXs ? (labelY < 200 ? labelY + 5 : labelY - 5) : labelY;

    const adjustedLabelX =
        labelX -
        unitX * ((labelGap ?? 30) + (lineToLabelGap ?? 0)) -
        (offsetGap ?? 0) -
        (lineEndAdjust ?? 0);
    const adjustedLabelY =
        labelY - unitY * ((gap ?? 30) + (lineToLabelGap ?? 0)) - (lineEndAdjust ?? 0);
    const adjustedPointX =
        pointX + 6 + unitX * ((gap ?? 30) + (lineToPointGap ?? 0)) + (lineStartAdjust ?? 0);
    const adjustedPointY =
        pointY + unitY * ((gap ?? 30) + (lineToPointGap ?? 0)) + (lineStartAdjust ?? 0);

    const icon = circleIcons[currentIcon];
    const iconHref = typeof icon === 'string' ? icon : icon.src;

    return (
        <svg
            style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
            data-testid={`annotation-${label}`}
        >
            <line
                x1={adjustedPointX}
                y1={adjustedPointY}
                x2={adjustedLabelX}
                y2={adjustedLabelY}
                stroke="#E5673E"
                strokeWidth={2}
            />
            <image
                href={iconHref}
                x={pointX - currentIcon * 2}
                y={pointY - currentIcon * 2}
                width={30 + currentIcon * 4}
                height={30 + currentIcon * 4}
                cursor="pointer"
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
                onClick={onClick}
            />
            {isInfotainment ? (
                <g>
                    <rect
                        x={adjustedLabelX - textWidth / 2 - 7}
                        y={adjustedLabelY - 15}
                        width={textWidth + 10}
                        height={30}
                        fill="#E5673E"
                    />
                    <text
                        ref={textRef}
                        x={adjustedLabelX}
                        y={adjustedLabelY}
                        fill="white"
                        fontSize={fontSize}
                        fontWeight="700"
                        fontFamily={'Poppins'}
                        dominantBaseline="middle"
                        textAnchor="middle"
                        cursor="pointer"
                        onClick={onClick}
                        onMouseEnter={() => setIsLabelHovered(true)}
                        onMouseLeave={() => setIsLabelHovered(false)}
                        style={{
                            textDecoration: isLabelHovered ? 'underline' : 'none',
                            textDecorationColor: isLabelHovered ? '#E5673E' : 'inherit',
                            textDecorationThickness: isLabelHovered ? '1px' : 'initial',
                        }}
                    >
                        {isScreenMd && typeof label === 'string'
                            ? wrappedLines.map((line, index) => (
                                  <tspan
                                      key={index}
                                      x={adjustedLabelX}
                                      dy={index === 0 ? 0 : '1.2em'}
                                      textAnchor="middle"
                                  >
                                      {line}
                                  </tspan>
                              ))
                            : Array.isArray(label)
                              ? label.map((line, index) => (
                                    <tspan
                                        key={index}
                                        x={adjustedLabelX}
                                        dy={index === 0 ? 0 : '1.2em'}
                                        textAnchor="middle"
                                    >
                                        {line}
                                    </tspan>
                                ))
                              : label}
                    </text>
                </g>
            ) : (
                <text
                    ref={textRef}
                    x={labelX}
                    y={modifiedLabelY}
                    fill="#E5673E"
                    fontSize={fontSize}
                    fontWeight="700"
                    fontFamily="Poppins"
                    textAnchor="middle"
                    cursor="pointer"
                    onClick={onClick}
                    onMouseEnter={() => setIsLabelHovered(true)}
                    onMouseLeave={() => setIsLabelHovered(false)}
                    style={{
                        textDecoration: isLabelHovered ? 'underline' : 'none',
                        textDecorationColor: isLabelHovered ? '#E5673E' : 'inherit',
                        textDecorationThickness: isLabelHovered ? '2px' : 'initial',
                    }}
                >
                    {typeof label === 'string'
                        ? wrappedLines.map((l, idx) => (
                              <tspan key={idx} x={labelX} dy={idx === 0 ? 0 : '1.2em'}>
                                  {l}
                              </tspan>
                          ))
                        : Array.isArray(label)
                          ? label.map((l, idx) => (
                                <tspan key={idx} x={labelX} dy={idx === 0 ? 0 : '1.2em'}>
                                    {l}
                                </tspan>
                            ))
                          : label}
                </text>
            )}
        </svg>
    );
};

export interface AutoImageProps {
    onAnnotationClick: (componentName: string) => void;
    onBack?: () => void;
    contentTree: ApplicationsContent;
    labelMap?: Map<string | number, string>;
}

export function processLabelToComponentName(label: string | string[]): string {
    let labelString: string;

    if (typeof label === 'string') {
        labelString = label;
    } else if (Array.isArray(label)) {
        labelString = label.join(' ');
    } else {
        labelString = '';
    }

    const match = labelString.match(/\(([^)]+)\)/);
    if (match) {
        labelString = match[1] || ''; // 提供預設值
    }
    labelString = labelString
        .toLowerCase()
        .replace(/\//g, '')
        .replace(/&/g, 'and')
        .replace(/\s+/g, '')
        .replace(/-/g, '')
        .replace(/[()]/g, '')
        .replace(/’/g, '');

    return labelString;
}

interface AnnotatedImageProps {
    imageSrc: string | StaticImageData;
    annotations: Array<{
        label: string | string[];
        displayName?: string | string[];
        pointX: number;
        pointY: number;
        labelX: number;
        labelY: number;
        gap?: number;
        labelGap?: number;
        offsetGap?: number;
        isInfotainment?: boolean;
        lineLengthAdjust?: number;
        lineStartAdjust?: number;
        lineEndAdjust?: number;
        lineToLabelGap?: number;
        lineToPointGap?: number;
    }>;
    onAnnotationClick: (componentName: string) => void;
    onBack?: () => void;
    imageStyle?: React.CSSProperties;
    isDefaultImage?: boolean;
    viewBox?: string;
}

const AnnotatedImage: React.FC<AnnotatedImageProps> = ({
    imageSrc,
    annotations,
    onAnnotationClick,
    onBack,
    imageStyle,
    isDefaultImage,
    viewBox = '0 0 1180 543',
}) => {
    const { isScreenSm, isScreenXs } = useResponsive();
    const resolvedImgSrc = typeof imageSrc === 'string' ? imageSrc : imageSrc.src; // ← 加這行

    if ((isScreenSm || isScreenXs) && !isDefaultImage) {
        return (
            <Box
                sx={{
                    display: 'grid',
                    gridTemplateColumns: '1fr 1fr',
                    gap: '1rem',
                }}
            >
                {annotations.map((annotation, index) => (
                    <Typography
                        key={index}
                        sx={{
                            position: 'relative',
                            paddingLeft: '1rem',
                            cursor: 'pointer',
                            color: 'black',
                            fontSize: '16px',
                            fontWeight: '400',
                            fontFamily: 'Poppins',
                            margin: 0,
                            '&::before': {
                                content: '"•"',
                                position: 'absolute',
                                left: 0,
                                color: 'black',
                            },
                            '&:hover': {
                                textDecoration: 'underline',
                                textDecorationColor: 'black',
                                textDecorationThickness: '2px',
                            },
                        }}
                        onClick={() => {
                            const componentName = processLabelToComponentName(annotation.label);
                            onAnnotationClick?.(componentName);
                        }}
                    >
                        {Array.isArray(annotation.label)
                            ? annotation.label.join(' ')
                            : annotation.label}
                    </Typography>
                ))}
            </Box>
        );
    }

    return (
        <Box
            sx={{
                position: 'relative',
                width: '100%',
                maxWidth: '1180px',
                margin: '0 auto',
                overflowX: 'hidden',
            }}
            data-testid={'reactive-image-zone'}
        >
            <img
                src={resolvedImgSrc}
                alt="Annotated"
                style={{ width: '100%', height: 'auto', ...imageStyle }}
            />
            <svg
                viewBox={viewBox}
                style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                }}
            >
                {annotations.map((annotation, index) => (
                    <Annotation
                        key={index}
                        label={annotation.displayName || annotation.label}
                        pointX={annotation.pointX}
                        pointY={annotation.pointY}
                        labelX={annotation.labelX}
                        labelY={annotation.labelY}
                        gap={annotation.gap}
                        labelGap={annotation.labelGap}
                        offsetGap={annotation.offsetGap}
                        isInfotainment={annotation.isInfotainment}
                        lineLengthAdjust={annotation.lineLengthAdjust}
                        lineStartAdjust={annotation.lineStartAdjust}
                        lineEndAdjust={annotation.lineEndAdjust}
                        lineToLabelGap={annotation.lineToLabelGap}
                        lineToPointGap={annotation.lineToPointGap}
                        onClick={() => {
                            const componentName = processLabelToComponentName(annotation.label);
                            onAnnotationClick?.(componentName);
                        }}
                    />
                ))}
                {onBack && (
                    <image
                        data-testid={'cross-icon'}
                        href={'/automotive_image/cross_icon.svg'}
                        x={1120}
                        y={0}
                        width={26}
                        height={26}
                        style={{ cursor: 'pointer', pointerEvents: 'all' }}
                        onClick={onBack}
                    />
                )}
            </svg>
        </Box>
    );
};

export default AnnotatedImage;

const DefaultAutomotive: React.FC<AutoImageProps> = ({ onAnnotationClick, labelMap }) => {
    const annotations = [
        {
            label: 'Powertrain',
            displayName: labelMap?.get('powertrain'),
            pointX: 230,
            pointY: 250,
            labelX: 95,
            labelY: 85,
            lineToLabelGap: -15,
            lineToPointGap: -21,
        },
        {
            label: 'Vehicle Electrification',
            displayName: labelMap?.get('vehicleelectrification'),
            pointX: 200,
            pointY: 105,
            labelX: 310,
            labelY: 40,
            lineStartAdjust: 9,
            lineToLabelGap: -10,
            lineToPointGap: -10,
        },
        {
            label: 'ADAS',
            displayName: labelMap?.get('adas'),
            pointX: 450,
            pointY: 70,
            labelX: 540,
            labelY: 20,
            lineStartAdjust: 7,
            lineToLabelGap: -9,
            lineToPointGap: -10,
        },
        {
            label: 'Infotainment',
            displayName: labelMap?.get('infotainment'),
            pointX: 620,
            pointY: 160,
            labelX: 740,
            labelY: 50,
            lineStartAdjust: 10,
            lineToLabelGap: -15,
            lineToPointGap: -10,
        },
        {
            label: 'Safety & Security',
            displayName: labelMap?.get('safetyandsecurity'),
            pointX: 850,
            pointY: 180,
            labelX: 950,
            labelY: 100,
            lineStartAdjust: 8,
            lineToLabelGap: -15,
            lineToPointGap: -12,
        },
        {
            label: 'Body Electronics',
            displayName: labelMap?.get('bodyelectronics'),
            pointX: 970,
            pointY: 280,
            labelX: 1035,
            labelY: 180,
            lineStartAdjust: 8,
            lineToLabelGap: -15,
            lineToPointGap: -12,
        },
    ];

    return (
        <AnnotatedImage
            imageSrc={carImage}
            annotations={annotations}
            onAnnotationClick={onAnnotationClick}
            imageStyle={{
                marginTop: '3rem',
                marginLeft: '1rem',
                width: '99%',
                height: 'auto',
            }}
            isDefaultImage
        />
    );
};

const PowerTrain: React.FC<AutoImageProps> = ({ onAnnotationClick, onBack, labelMap }) => {
    const responsiveMargins = useResponsiveMargins('powertrain');

    const annotations = [
        {
            label: 'Radiator Fan',
            displayName: labelMap?.get('radiatorfan'),
            pointX: 160,
            pointY: 240,
            labelX: 100,
            labelY: 75,
            lineToLabelGap: -15,
            lineToPointGap: -20,
        },
        {
            label: 'Transmission Control Unit (TCU)',
            displayName: labelMap?.get('tcu'),
            pointX: 460,
            pointY: 230,
            labelX: 360,
            labelY: 26,
            lineToLabelGap: -15,
            lineToPointGap: -20,
        },
        {
            label: ['Fuel Injection System', '(Direct Injection)'],
            displayName: labelMap?.get('directinjection'),
            pointX: 640,
            pointY: 230,
            labelX: 720,
            labelY: 26,
            lineLengthAdjust: -40,
            lineStartAdjust: 7,
            lineToLabelGap: 10,
            lineToPointGap: -15,
        },
        {
            label: 'eTurbo/eBoost',
            displayName: labelMap?.get('eturboeboost'),
            pointX: 760,
            pointY: 160,
            labelX: 960,
            labelY: 75,
            lineStartAdjust: 10,
            lineToPointGap: -12,
        },
        {
            label: ['Exhaust Gas', 'Recirculation (EGR)'],
            displayName: labelMap?.get('egr'),
            pointX: 900,
            pointY: 220,
            labelX: 1020,
            labelY: 160,
            lineLengthAdjust: 100,
            lineToLabelGap: 50,
            lineStartAdjust: 12,
            lineEndAdjust: -15,
        },
        {
            label: 'Fuel Pump',
            displayName: labelMap?.get('fuelpump'),
            pointX: 820,
            pointY: 240,
            labelX: 1050,
            labelY: 300,
            lineLengthAdjust: 180,
            lineStartAdjust: 19,
            lineEndAdjust: -15,
            lineToLabelGap: 130,
        },
        {
            label: 'Throttle Control',
            displayName: labelMap?.get('throttlecontrol'),
            pointX: 775,
            pointY: 265,
            labelX: 1030,
            labelY: 370,
            lineStartAdjust: 24,
            lineEndAdjust: -50,
            lineLengthAdjust: 260,
            lineToLabelGap: 300,
            lineToPointGap: -20,
        },
        {
            label: 'Engine Control Unit (ECU)',
            displayName: labelMap?.get('ecu'),
            pointX: 750,
            pointY: 310,
            labelX: 950,
            labelY: 470,
            lineStartAdjust: 20,
            lineToPointGap: -20,
            lineLengthAdjust: -70,
        },
        {
            label: 'Ignition System',
            displayName: labelMap?.get('ignitionsystem'),
            pointX: 720,
            pointY: 245,
            labelX: 650,
            labelY: 500,
            offsetGap: 0,
            lineStartAdjust: 8,
        },
        {
            label: ['Variable Valve', 'Timing System (VVT)'],
            displayName: labelMap?.get('vvt'),
            pointX: 645,
            pointY: 280,
            labelX: 170,
            labelY: 480,
            offsetGap: 0,
            lineStartAdjust: 12,
            lineToLabelGap: 45,
        },
    ];

    return (
        <AnnotatedImage
            imageSrc={powerTrainImage}
            annotations={annotations}
            onAnnotationClick={onAnnotationClick}
            onBack={onBack}
            imageStyle={{
                ...responsiveMargins,
                width: '76%',
                height: 'auto',
            }}
        />
    );
};

const Adas: React.FC<AutoImageProps> = ({ onAnnotationClick, onBack, labelMap }) => {
    const responsiveMargins = useResponsiveMargins('adas');

    const annotations = [
        {
            label: 'Radar',
            displayName: labelMap?.get('radar'),
            pointX: 120,
            pointY: 400,
            labelX: 80,
            labelY: 200,
            lineLengthAdjust: 200,
        },
        {
            label: 'Lidar',
            displayName: labelMap?.get('lidar'),
            pointX: 400,
            pointY: 155,
            labelX: 300,
            labelY: 70,
            lineStartAdjust: 30,
            lineToLabelGap: -15,
            lineToPointGap: 20,
        },
        {
            label: 'Cameras',
            displayName: labelMap?.get('cameras'),
            pointX: 440,
            pointY: 163,
            labelX: 550,
            labelY: 20,
            lineStartAdjust: 8,
            lineLengthAdjust: 100,
        },
        {
            label: 'Adaptive Lighting',
            displayName: labelMap?.get('adaptivelighting'),
            pointX: 220,
            pointY: 400,
            labelX: 700,
            labelY: 430,
            lineStartAdjust: 14,
            lineEndAdjust: 3,
            lineToLabelGap: 90,
        },
        {
            label: 'Ultra Sonic Sensors',
            displayName: labelMap?.get('ultrasonicsensors'),
            pointX: 150,
            pointY: 465,
            labelX: 650,
            labelY: 530,
            lineStartAdjust: 14,
            lineEndAdjust: -8,
            lineToLabelGap: 110,
        },
    ];

    return (
        <AnnotatedImage
            imageSrc={adasImage}
            annotations={annotations}
            onAnnotationClick={onAnnotationClick}
            onBack={onBack}
            imageStyle={{
                ...responsiveMargins,
                width: '85%',
                height: 'auto',
            }}
        />
    );
};

const VehicleElectrification: React.FC<AutoImageProps> = ({
    onAnnotationClick,
    onBack,
    labelMap,
}) => {
    const responsiveMargins = useResponsiveMargins('vehicleElectrification');

    const annotations = [
        {
            label: 'DC/DC Converter',
            displayName: labelMap?.get('dcdcconverter'),
            pointX: 220,
            pointY: 200,
            labelX: 160,
            labelY: 45,
            lineLengthAdjust: 170,
        },
        {
            label: 'Electric Motor/Generator',
            displayName: labelMap?.get('electricmotorgenerator'),
            pointX: 760,
            pointY: 210,
            labelX: 500,
            labelY: 35,
            lineLengthAdjust: 90,
            lineStartAdjust: 8,
        },
        {
            label: 'Traction Inverter',
            displayName: labelMap?.get('tractioninverter'),
            pointX: 810,
            pointY: 200,
            labelX: 810,
            labelY: 20,
            lineLengthAdjust: 130,
            lineStartAdjust: 5,
        },
        {
            label: 'Onboard Charger',
            displayName: labelMap?.get('onboardcharger'),
            pointX: 820,
            pointY: 280,
            labelX: 1000,
            labelY: 470,
            lineStartAdjust: 6,
        },
        {
            label: 'Battery Management System',
            displayName: labelMap?.get('batterymanagementsystem'),
            pointX: 710,
            pointY: 260,
            labelX: 730,
            labelY: 490,
            lineStartAdjust: 6,
        },
        {
            label: 'Vehicle Wireless Charging',
            displayName: labelMap?.get('vehiclewirelesscharging'),
            pointX: 360,
            pointY: 320,
            labelX: 330,
            labelY: 500,
            lineStartAdjust: 7,
        },
    ];

    return (
        <AnnotatedImage
            imageSrc={vehicleElectrificationImage}
            annotations={annotations}
            onAnnotationClick={onAnnotationClick}
            onBack={onBack}
            imageStyle={{
                ...responsiveMargins,
                width: '76%',
                height: 'auto',
            }}
        />
    );
};

const Infotainment: React.FC<AutoImageProps> = ({ onAnnotationClick, onBack, labelMap }) => {
    const annotations = [
        {
            label: 'Instrument Cluster',
            displayName: labelMap?.get('instrumentcluster'),
            pointX: 310,
            pointY: 200,
            labelX: 210,
            labelY: 100,
            lineLengthAdjust: 200,
            isInfotainment: true,
        },
        {
            label: 'Head-Up Display',
            displayName: labelMap?.get('headupdisplay'),
            pointX: 340,
            pointY: 145,
            labelX: 500,
            labelY: 35,
            lineStartAdjust: 10,
            isInfotainment: true,
        },
        {
            label: 'Navigation',
            displayName: labelMap?.get('navigation'),
            pointX: 500,
            pointY: 200,
            labelX: 680,
            labelY: 95,
            lineStartAdjust: 10,
            isInfotainment: true,
        },
        {
            label: 'Night Vision',
            displayName: labelMap?.get('nightvision'),
            pointX: 510,
            pointY: 330,
            labelX: 690,
            labelY: 240,
            lineStartAdjust: 10,
            isInfotainment: true,
        },
    ];

    return (
        <AnnotatedImage
            imageSrc={infotainmentImage}
            annotations={annotations}
            onAnnotationClick={onAnnotationClick}
            onBack={onBack}
            imageStyle={{
                marginTop: '1rem',
                marginBottom: '1rem',
                marginLeft: '5rem',
                width: '76%',
                height: 'auto',
            }}
        />
    );
};

const SafetyAndSecurity: React.FC<AutoImageProps> = ({ onAnnotationClick, onBack, labelMap }) => {
    const annotations = [
        {
            label: 'Keyless Entry',
            displayName: labelMap?.get('keylessentry'),
            pointX: 290,
            pointY: 160,
            labelX: 120,
            labelY: 90,
            lineStartAdjust: 18,
        },
        {
            label: 'Anti-Theft GPS',
            displayName: labelMap?.get('antitheftgps'),
            pointX: 320,
            pointY: 80,
            labelX: 250,
            labelY: 45,
            lineStartAdjust: 18,
            lineLengthAdjust: 20,
            lineToPointGap: 8,
        },
        {
            label: 'Airbag Deployment',
            displayName: labelMap?.get('airbagdeployment'),
            pointX: 390,
            pointY: 130,
            labelX: 500,
            labelY: 20,
            lineStartAdjust: 8,
            lineLengthAdjust: 100,
        },
        {
            label: 'Auto Dimming Mirror',
            displayName: labelMap?.get('autodimmingmirror'),
            pointX: 610,
            pointY: 120,
            labelX: 700,
            labelY: 50,
            lineStartAdjust: 10,
            lineLengthAdjust: 100,
        },
        {
            label: 'Windshield Wiper Control',
            displayName: labelMap?.get('windshieldwipercontrol'),
            pointX: 680,
            pointY: 130,
            labelX: 900,
            labelY: 100,
            lineStartAdjust: 13,
            lineToLabelGap: 50,
            lineToPointGap: -10,
        },
        {
            label: 'OBD II',
            displayName: labelMap?.get('obdii'),
            pointX: 610,
            pointY: 170,
            labelX: 950,
            labelY: 170,
            lineStartAdjust: 13,
            lineEndAdjust: -5,
            lineToLabelGap: 20,
            lineToPointGap: -10,
        },
        {
            label: ['Telematic', 'Control Unit'],
            displayName: labelMap?.get('telematiccontrolunit'),
            pointX: 820,
            pointY: 280,
            labelX: 1030,
            labelY: 250,
            lineStartAdjust: 13,
            lineToLabelGap: 50,
            lineToPointGap: -10,
        },
        { label: 'TPMS', pointX: 140, pointY: 320, labelX: 80, labelY: 480, lineStartAdjust: 8 },
    ];

    return (
        <AnnotatedImage
            imageSrc={carImage}
            annotations={annotations}
            onAnnotationClick={onAnnotationClick}
            onBack={onBack}
            imageStyle={{
                marginTop: '3rem',
                marginLeft: '1rem',
                width: '99%',
                height: 'auto',
            }}
        />
    );
};

const BodyElectronics: React.FC<AutoImageProps> = ({ onAnnotationClick, onBack, labelMap }) => {
    const responsiveMargins = useResponsiveMargins('bodyElectronics');

    const annotations = [
        {
            label: ['Electric Water', 'Pump'],
            displayName: labelMap?.get('electricwaterpump'),
            pointX: 310,
            pointY: 350,
            labelX: 130,
            labelY: 300,
            lineStartAdjust: 15,
            lineToLabelGap: 30,
        },
        {
            label: ['Electric Power', 'Steering'],
            displayName: labelMap?.get('electricpowersteering'),
            pointX: 310,
            pointY: 280,
            labelX: 140,
            labelY: 210,
            lineStartAdjust: 15,
            lineToLabelGap: 40,
        },
        {
            label: 'Wireless Charging',
            displayName: labelMap?.get('wirelesscharging'),
            pointX: 530,
            pointY: 210,
            labelX: 130,
            labelY: 115,
            lineStartAdjust: 15,
            lineEndAdjust: -10,
            lineToLabelGap: -18,
        },
        {
            label: 'Windows',
            displayName: labelMap?.get('windows'),
            pointX: 380,
            pointY: 100,
            labelX: 240,
            labelY: 55,
            lineStartAdjust: 15,
        },
        {
            label: 'Sunroof',
            displayName: labelMap?.get('sunroof'),
            pointX: 530,
            pointY: 70,
            labelX: 548,
            labelY: 18,
            lineStartAdjust: -4,
            lineEndAdjust: -10,
            lineToLabelGap: 10,
            lineToPointGap: 10,
        },
        {
            label: 'Wire Harness',
            displayName: labelMap?.get('wireharness'),
            pointX: 680,
            pointY: 100,
            labelX: 800,
            labelY: 30,
            lineStartAdjust: 11,
            lineToLabelGap: -12,
            lineToPointGap: -10,
        },
        {
            label: 'Seat Control',
            displayName: labelMap?.get('seatcontrol'),
            pointX: 650,
            pointY: 150,
            labelX: 950,
            labelY: 90,
            lineStartAdjust: 11,
            lineToLabelGap: 20,
        },
        {
            label: ['Electric', 'Compressor'],
            displayName: labelMap?.get('electriccompressor'),
            pointX: 670,
            pointY: 250,
            labelX: 1045,
            labelY: 190,
            lineStartAdjust: 11,
            lineToLabelGap: 60,
        },
    ];

    return (
        <AnnotatedImage
            imageSrc={bodyElectronicsImage}
            annotations={annotations}
            onAnnotationClick={onAnnotationClick}
            onBack={onBack}
            imageStyle={{
                ...responsiveMargins,
                width: '76%',
                height: 'auto',
            }}
        />
    );
};
interface svgList {
    label: string;
    link?: string;
}
export interface ThirdLayerImageProps {
    onBack: () => void;
}

export interface FullscreenImageProps {
    imageSrc: string;
    onBack: () => void;
}
export interface FullscreenSvgProps {
    onBack: () => void;
    svgList?: svgList[];
    svgUrl: string;
}

export const FullscreenSvg: React.FC<FullscreenSvgProps> = ({
    onBack,
    svgList: propSvgList,
    svgUrl,
}) => {
    const { isScreenXl, isScreenLg, isScreenMd, isScreenSm, isScreenXs } = useResponsive();
    const navigate = useNavigate();

    let iconWidth, iconHeight;
    if (isScreenXl) {
        iconWidth = 29;
        iconHeight = 26;
    } else if (isScreenLg) {
        iconWidth = 25;
        iconHeight = 22;
    } else if (isScreenMd) {
        iconWidth = 21;
        iconHeight = 19;
    } else if (isScreenSm) {
        iconWidth = 17;
        iconHeight = 15;
    } else if (isScreenXs) {
        iconWidth = 14;
        iconHeight = 12;
    } else {
        iconWidth = 29;
        iconHeight = 26;
    }

    const [svgList, setSvgList] = useState<svgList[]>([]);
    const [svgHtml, setSvgHtml] = useState<string>(
        `<div style="padding:${iconHeight * 1.8}%"></div> `
    );

    useEffect(() => {
        if (svgUrl) {
            fetch(svgUrl)
                .then((res) => res.text())
                .then((svgText) => {
                    setSvgHtml(svgText);
                    const parser = new DOMParser();
                    const svgDoc = parser.parseFromString(svgText, 'image/svg+xml');
                    // get all <a> tag
                    const aElements = svgDoc.getElementsByTagName('a');
                    const list: svgList[] = [];
                    for (let i = 0; i < aElements.length; i++) {
                        const aElem = aElements[i]!;
                        // check title attribute
                        const label = aElem.getAttribute('title') || aElem.textContent || '';
                        // check href attribute
                        const link =
                            aElem.getAttribute('href') ||
                            aElem.getAttribute('xlink:href') ||
                            undefined;
                        list.push({ label, link });
                    }
                    setSvgList(list);
                })
                .catch((error) => {
                    console.error('Error reading SVG file:', error);
                });
        }
    }, [svgUrl]);

    const finalSvgList = propSvgList ? propSvgList : svgList;

    return isScreenSm || isScreenXs ? (
        <Box
            data-testid={`fullscreen-svg-small`}
            sx={{
                display: 'grid',
                gridTemplateColumns: '1fr 1fr',
                gap: '1rem',
                minHeight: `500px`,
            }}
        >
            {finalSvgList.map((item, index) => (
                <Typography
                    key={index}
                    sx={{
                        position: 'relative',
                        paddingLeft: '1rem',
                        cursor: 'pointer',
                        color: 'black',
                        fontSize: '16px',
                        fontWeight: '400',
                        fontFamily: 'Poppins',
                        margin: 0,
                        '&::before': {
                            content: '"•"',
                            position: 'absolute',
                            left: 0,
                            color: 'black',
                        },
                        '&:hover': {
                            textDecoration: 'underline',
                            textDecorationColor: 'black',
                            textDecorationThickness: '2px',
                        },
                    }}
                    onClick={() => {
                        if (item.link) {
                            if (item.link.startsWith('/')) {
                                // TODO: Do we need this?
                                navigate(item.link);
                            } else {
                                window.open(item.link, '_blank');
                            }
                        }
                    }}
                >
                    {item.label}
                </Typography>
            ))}
        </Box>
    ) : (
        <Box
            data-testid={`fullscreen-svg-normal`}
            sx={{
                width: '100%',
                position: 'relative',
                overflow: 'hidden',
            }}
        >
            <Box
                sx={{
                    position: 'relative',
                    display: 'inline-block',
                    width: GetResponsiveWidth,
                    cursor: 'pointer',
                    pointerEvents: 'all',
                    overflow: 'hidden',
                }}
            >
                {/* use dangerouslySetInnerHTML for SVG HTML TODO - SANITIZE!!!*/}
                <div dangerouslySetInnerHTML={{ __html: svgHtml }} />
                <Image
                    src={'/automotive_image/cross_icon.svg'}
                    alt="Close Icon"
                    width={Number(iconWidth)}
                    height={Number(iconHeight)}
                    style={{
                        position: 'absolute',
                        top: 0,
                        right: 0,
                        cursor: 'pointer',
                        pointerEvents: 'all',
                    }}
                    onClick={onBack}
                />
            </Box>
        </Box>
    );
};

const DigitalPassiveImage: React.FC<ThirdLayerImageProps> = ({ onBack }) => {
    return (
        <FullscreenSvg
            svgUrl={'/automotive_image/automotive_Digital_Passive_Components_relative.svg'}
            onBack={onBack}
        />
    );
};

const TractionInverterImage: React.FC<ThirdLayerImageProps> = ({ onBack }) => {
    return (
        <FullscreenSvg
            onBack={onBack}
            svgUrl={'/automotive_image/automotive_Traction_Inverter_Motor_Generator_relative.svg'}
        />
    );
};

const BmsLowVoltImage: React.FC<ThirdLayerImageProps> = ({ onBack }) => {
    return (
        <FullscreenSvg
            svgUrl={'/industrual_image/commerical_Digital_Passive_Components.svg'}
            onBack={onBack}
        />
    );
};

const DcdcConverterImage: React.FC<ThirdLayerImageProps> = ({ onBack }) => {
    return (
        <FullscreenSvg
            svgUrl={'/automotive_image/automotive_DC_DC_Converter_relative.svg'}
            onBack={onBack}
        />
    );
};

const PowerConversionImage: React.FC<ThirdLayerImageProps> = ({ onBack }) => {
    return (
        <FullscreenSvg
            svgUrl={'/automotive_image/automotive_Power_Conversion_AC_DC_relative.svg'}
            onBack={onBack}
        />
    );
};
const BmsLowVoltRelative: React.FC<ThirdLayerImageProps> = ({ onBack }) => {
    return (
        <FullscreenSvg
            svgUrl={'/automotive_image/automotive_BMS_Low_Voltage_Circuit_relative.svg'}
            onBack={onBack}
        />
    );
};
export {
    DefaultAutomotive,
    Adas,
    PowerTrain,
    VehicleElectrification,
    Infotainment,
    SafetyAndSecurity,
    BodyElectronics,
    DigitalPassiveImage,
    TractionInverterImage,
    BmsLowVoltImage,
    DcdcConverterImage,
    PowerConversionImage,
    BmsLowVoltRelative,
};
